import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaBitacora from './TablaBitacora';

const Bitacora: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaBitacora />
    </Box>
  );
};

export default Bitacora;
